import React from 'react';
import ColorPicker from '../ui/ColorPicker';

const DividerBlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Divider Settings</h4>

        <div className="editor-field">
          <label>Line Style</label>
          <select
            value={block.config.style || 'solid'}
            onChange={(e) => handleChange('style', e.target.value)}
          >
            <option value="solid">Solid</option>
            <option value="dashed">Dashed</option>
            <option value="dotted">Dotted</option>
            <option value="double">Double</option>
          </select>
        </div>

        <div className="editor-field">
          <ColorPicker
            label="Line Color"
            color={block.config.color || '#333333'}
            onChange={(value) => handleChange('color', value)}
          />
        </div>

        <div className="editor-field">
          <label>Thickness (px)</label>
          <input
            type="range"
            min="1"
            max="10"
            step="1"
            value={block.config.thickness || 1}
            onChange={(e) => handleChange('thickness', parseInt(e.target.value))}
            style={{ width: '100%' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
            <span style={{ color: '#999', fontSize: '0.875rem' }}>1px</span>
            <span style={{ color: '#fff', fontWeight: 'bold' }}>{block.config.thickness || 1}px</span>
            <span style={{ color: '#999', fontSize: '0.875rem' }}>10px</span>
          </div>
        </div>

        <div className="editor-field">
          <label>Width (%)</label>
          <input
            type="range"
            min="10"
            max="100"
            step="5"
            value={block.config.width || 100}
            onChange={(e) => handleChange('width', parseInt(e.target.value))}
            style={{ width: '100%' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
            <span style={{ color: '#999', fontSize: '0.875rem' }}>10%</span>
            <span style={{ color: '#fff', fontWeight: 'bold' }}>{block.config.width || 100}%</span>
            <span style={{ color: '#999', fontSize: '0.875rem' }}>100%</span>
          </div>
        </div>

        <div className="editor-field">
          <label>Alignment</label>
          <select
            value={block.config.align || 'center'}
            onChange={(e) => handleChange('align', e.target.value)}
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>

        <div className="editor-field">
          <label>Margin (px)</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
            <div>
              <label style={{ fontSize: '0.75rem', color: '#999' }}>Top</label>
              <input
                type="number"
                value={block.config.marginTop || 0}
                onChange={(e) => handleChange('marginTop', parseInt(e.target.value))}
                placeholder="Top"
                min="0"
                max="100"
              />
            </div>
            <div>
              <label style={{ fontSize: '0.75rem', color: '#999' }}>Bottom</label>
              <input
                type="number"
                value={block.config.marginBottom || 0}
                onChange={(e) => handleChange('marginBottom', parseInt(e.target.value))}
                placeholder="Bottom"
                min="0"
                max="100"
              />
            </div>
          </div>
        </div>

        <div style={{
          marginTop: '1.5rem',
          padding: '1rem',
          backgroundColor: '#1a1a1a',
          borderRadius: '0.375rem',
          border: '1px solid #333'
        }}>
          <div style={{ color: '#999', fontSize: '0.875rem', marginBottom: '0.5rem' }}>Preview</div>
          <div style={{
            padding: `${block.config.marginTop || 0}px 0 ${block.config.marginBottom || 0}px 0`,
            display: 'flex',
            justifyContent: block.config.align === 'left' ? 'flex-start' : block.config.align === 'right' ? 'flex-end' : 'center'
          }}>
            <hr style={{
              border: 'none',
              borderTop: `${block.config.thickness || 1}px ${block.config.style || 'solid'} ${block.config.color || '#333333'}`,
              margin: 0,
              width: `${block.config.width || 100}%`
            }} />
          </div>
        </div>

        <div className="editor-field">
          <label>Style Presets</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginTop: '0.5rem' }}>
            <button
              type="button"
              onClick={() => {
                handleChange('style', 'solid');
                handleChange('thickness', 1);
                handleChange('color', '#333333');
              }}
              style={{
                padding: '0.75rem',
                fontSize: '0.75rem',
                backgroundColor: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Subtle
              <div style={{ borderTop: '1px solid #666', marginTop: '0.5rem' }}></div>
            </button>
            <button
              type="button"
              onClick={() => {
                handleChange('style', 'solid');
                handleChange('thickness', 3);
                handleChange('color', '#ff0080');
              }}
              style={{
                padding: '0.75rem',
                fontSize: '0.75rem',
                backgroundColor: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Bold
              <div style={{ borderTop: '3px solid #ff0080', marginTop: '0.5rem' }}></div>
            </button>
            <button
              type="button"
              onClick={() => {
                handleChange('style', 'dashed');
                handleChange('thickness', 2);
                handleChange('color', '#666666');
              }}
              style={{
                padding: '0.75rem',
                fontSize: '0.75rem',
                backgroundColor: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Dashed
              <div style={{ borderTop: '2px dashed #666', marginTop: '0.5rem' }}></div>
            </button>
            <button
              type="button"
              onClick={() => {
                handleChange('style', 'dotted');
                handleChange('thickness', 2);
                handleChange('color', '#999999');
              }}
              style={{
                padding: '0.75rem',
                fontSize: '0.75rem',
                backgroundColor: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Dotted
              <div style={{ borderTop: '2px dotted #999', marginTop: '0.5rem' }}></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DividerBlockEditor;
